var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_105_836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2 0H9.8C4.388 0 0 4.388 0 9.8v29.4C0 44.612 4.388 49 9.8 49h29.4c5.412 0 9.8-4.388 9.8-9.8V9.8C49 4.388 44.612 0 39.2 0z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.977 17.826c0-1.61-.397-2.79-1.177-4.048a8.109 8.109 0 00-3.204-2.935c-1.33-.69-2.882-1.037-4.61-1.037H16.46a2.688 2.688 0 00-2.69 2.67 2.657 2.657 0 002.645 2.668h8.57c1.117 0 1.992.252 2.672.769.596.452.885.895.885 1.914 0 1.02-.291 1.424-.891 1.887-.68.527-1.552.782-2.667.782h-.459a2.678 2.678 0 00-2.687 2.669 2.678 2.678 0 002.687 2.67h1.19c1.364 0 3.027-.599 3.88-1.038a8.11 8.11 0 003.203-2.935c.781-1.257 1.177-2.384 1.177-3.997v-.017l.002-.022z",
    fill: "#96E650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.15 12.472A2.681 2.681 0 0016.46 9.8a2.681 2.681 0 00-2.69 2.672v24.05a2.681 2.681 0 002.69 2.672 2.681 2.681 0 002.69-2.673V12.472zM24.573 25.827a2.681 2.681 0 002.674-2.689 2.681 2.681 0 00-2.706-2.656 2.681 2.681 0 00-2.674 2.688 2.681 2.681 0 002.706 2.657z",
    fill: "#000F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46 15.145a2.681 2.681 0 002.69-2.673A2.681 2.681 0 0016.46 9.8a2.681 2.681 0 00-2.69 2.672 2.681 2.681 0 002.69 2.673zM25.716 25.833h-.273c.432-.001.863.04 1.287.12l.313.07c.281.07.555.167.817.288.384.17.73.411 1.022.711.334.354.522.546.737 1.068.176.483.271.993.282 1.507v.242c0 .88-.149 1.618-.507 2.177a3.644 3.644 0 01-1.539 1.348c-.681.31-1.494.475-2.418.475h-8.983a2.694 2.694 0 00-2.37 1.328c-.489.836-.485 1.87.01 2.702a2.695 2.695 0 002.377 1.313h8.966c1.894 0 3.554-.399 5.035-1.187a8.975 8.975 0 003.532-3.296c.847-1.395 1.276-3.07 1.276-4.866a11.285 11.285 0 00-.235-2.222 8.577 8.577 0 00-1.043-2.643 8.792 8.792 0 00-1.885-2.19 8.2 8.2 0 01-2.53 2.01c-.852.443-2.515 1.037-3.878 1.037",
    fill: "#4BDBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.508 39.184a2.681 2.681 0 002.674-2.688 2.681 2.681 0 00-2.706-2.657 2.681 2.681 0 00-2.674 2.689 2.681 2.681 0 002.706 2.656z",
    fill: "#96E650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_105_836"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h49v49H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.152544f59023623cae45bae0e23e4ab5.svg";
export { ForwardRef as ReactComponent };